import { useQuery } from "@tanstack/react-query";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { integrationQueryKeys } from "@/integration/data/integrationQueryKeys";

export function useLinearArchiveGuideOptions(options?: { enabled?: boolean }) {
  const { org } = useEnvironment();

  return useQuery({
    queryKey: integrationQueryKeys.linearArchiveGuideOptions(org.id),
    queryFn: () =>
      api
        .get<"/orgs/:orgId/linear/connection/archive-guide-options">(
          `/orgs/${org.id}/linear/connection/archive-guide-options`,
        )
        .then((res) => res.data),
    enabled: Boolean(org) && options?.enabled !== false,
    staleTime: 1000 * 10,
  });
}
